import type { ClusterMarker } from './cluster-marker.class';
import type { PropertyMarker } from './property-marker.class';

export type MarkerType = 'property' | 'cluster';

export type MapMarker = PropertyMarker | ClusterMarker;

export class Marker {
  private constructor() { }

  static async create(
    lat: number,
    lng: number,
    map: google.maps.Map,
    type: MarkerType = 'property',
    subType = 'filtered',
    value?: string,
    meta?: any
  ): Promise<MapMarker> {
    if (!map) {
      throw new Error(
        'A valid Google Maps instance is required to create a marker.'
      );
    }

    // Support both newer library loading and existing script loaders.
    // The cast also supports projects using older Google Maps typings.
    const maps = google.maps as typeof google.maps & {
      importLibrary?: (name: string) => Promise<unknown>;
    };

    if (typeof maps.importLibrary === 'function') {
      await maps.importLibrary('maps');
    }

    if (typeof maps.OverlayView !== 'function') {
      throw new Error(
        'Google Maps OverlayView is not ready. Call Marker.create() after the Maps API has loaded.'
      );
    }

    if (type === 'cluster') {
      const { createClusterMarker } = await import(
        './cluster-marker.class'
      );

      return createClusterMarker(
        lat,
        lng,
        value ?? '',
        map,
        meta
      );
    }

    const { PropertyMarker } = await import(
      './property-marker.class'
    );

    return new PropertyMarker(
      lat,
      lng,
      subType,
      value ?? '',
      map,
      meta
    );
  }
}